export default __webpack_public_path__ + "static/media/OSI_logo.7154d5df.svg";